/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { Tabs } from "../../Helper/Tabs";

export const DataTestId = {
    TAB: "TAB",
    TAB_CONTENT: "TAB_CONTENT",
};


export default function StagesTabs({ activeTab, switchTab, sameCategoryTabs, children }) {
    return (

        <div >
            <Tabs
                tabs={sameCategoryTabs?.map((tab, index) => ({ ...tab, "data-testid": `${DataTestId.TAB}${index}` }))}
                activeTab={activeTab?.value}
                onSwitchTab={switchTab}
            />

            <div className="bg-white px-3 py-3" css={css`border-radius: 0px 8px 8px 8px;`} >
                {children}
            </div>
        </div>


    );
}
